/** Godot 4.6.3's 1D Curve facts a scene's properties carry. */
/**
 * `Curve::TangentMode` (`scene/resources/curve.h:44-48`), each member without `TANGENT_`.
 * `TANGENT_MODE_COUNT` is a size marker and is left out.
 */
export const CurveTangentMode = {
    FREE: 0,
    LINEAR: 1,
};
//# sourceMappingURL=curve.js.map